import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';

import {
  Applications,
  ApplicationService,
  CopyService
} from '@amfam/shared/utility/shared-services';
import { AlertModalConfig, DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-auto-pay-delete-modal-wrapper',
  templateUrl: './auto-pay-delete-modal-wrapper.component.html',
  styleUrls: ['./auto-pay-delete-modal-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutoPayDeleteModalWrapperComponent implements OnChanges {
  @Input() displayDeleteAutoPayDiscountMessage: boolean;
  @Output() deleteConfirmEvent: EventEmitter<void> = new EventEmitter<void>();

  modalConfig: AlertModalConfig;

  constructor(
    private modalService: DsModalService,
    private copyService: CopyService,
    private appService: ApplicationService
  ) {}

  ngOnChanges(): void {
    let bodyText = '';
    if (this.appService.isApp(Applications.MYACCOUNT_ADMIN)) {
      bodyText = this.displayDeleteAutoPayDiscountMessage
        ? this.copyService.getCopy(
            'billing.autoPayRefactor.adminToolDeleteModalBodyTextAutoPayDiscount'
          )
        : this.copyService.getCopy('billing.autoPayRefactor.adminToolDeleteModalBodyText');
    } else {
      bodyText = this.displayDeleteAutoPayDiscountMessage
        ? this.copyService.getCopy('billing.autoPayRefactor.deleteModalBodyTextAutoPayDiscount')
        : this.copyService.getCopy('billing.autoPayRefactor.deleteModalBodyText');
    }

    this.modalConfig = {
      headerText: this.copyService.getCopy('billing.autoPayRefactor.deleteModalHeadingText'),
      bodyText,
      modalId: 'autoPayDeleteModal',
      ctaConfig: {
        primaryButtonName: 'Yes, Delete',
        tertiaryButtonName: 'No, keep it',
        fullWidthButtons: true,
        primaryButtonDestructive: true
      }
    };
  }

  closeModal() {
    this.modalService.close('autoPayDeleteModal');
  }
}
